export default function Testimonials() {
  const testimonials = [
    {
      name: 'María González',
      location: 'Madrid',
      image: 'https://public.readdy.ai/ai/img_res/0ab631588e881d9319fbaf1b18c1466c.jpg',
      text: 'Ganaba 900€/mes, ahora 1.800€. ¡Y sin hacer nada! El equipo de STAYX es increíblemente profesional.',
      rating: 5
    },
    {
      name: 'Carlos Ruiz',
      location: 'Barcelona',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20spanish%20man%20in%20his%2050s%20smiling%20business%20casual%20attire%20natural%20lighting%20soft%20beige%20background%20friendly%20trustworthy%20property%20owner%20satisfied%20client&width=400&height=400&seq=testimonial-stayx-002&orientation=squarish',
      text: 'La mejor decisión para rentabilizar mi apartamento. Transparencia total y resultados desde el primer mes.',
      rating: 5
    },
    {
      name: 'Laura Martínez',
      location: 'Valencia',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20spanish%20woman%20in%20her%2030s%20smiling%20warmly%20business%20casual%20attire%20natural%20lighting%20soft%20beige%20background%20friendly%20modern%20property%20owner%20happy%20testimonial&width=400&height=400&seq=testimonial-stayx-003&orientation=squarish',
      text: 'Transparencia, buena comunicación y cero estrés. No tengo que preocuparme de nada, todo funciona perfecto.',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Andrea'] text-4xl lg:text-5xl font-bold text-[#2C3E50] mb-4">
            Lo que dicen otros propietarios
          </h2>
          <p className="font-['Satoshi'] text-lg text-gray-600 max-w-2xl mx-auto">
            Historias reales de propietarios que han transformado sus propiedades en fuentes de ingresos
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-['Andrea'] text-lg font-bold text-[#2C3E50]">
                    {testimonial.name}
                  </h4>
                  <p className="font-['Satoshi'] text-sm text-gray-600">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="font-['Satoshi'] text-sm text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="font-['Satoshi'] text-lg text-gray-600 mb-6">
            Únete a más de 200 propietarios satisfechos
          </p>
          <div className="flex justify-center items-center gap-4 flex-wrap">
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-yellow-400 text-2xl"></i>
              <span className="font-['Andrea'] text-2xl font-bold text-[#2C3E50]">4.9</span>
              <span className="font-['Satoshi'] text-sm text-gray-600">/5.0</span>
            </div>
            <span className="font-['Satoshi'] text-sm text-gray-400">•</span>
            <span className="font-['Satoshi'] text-sm text-gray-600">Basado en 180+ reseñas</span>
          </div>
        </div>
      </div>
    </section>
  );
}
